import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {classNamesPrefixed} from '../../../helpers/CoreHelpers';
import {Icon} from "../UI/Icon";

class InputWrap extends Component {

    constructor(props) {
        super();
        this.state = {
            focused: false
        };
    }

    render() {
        /**
         * @param classes {string} Parameter for appending any additional extra classes
         */
        const {focused, children, label, id, type, icon, error, warning, required, helpText, classes } = this.props;

        let inputType = "text";
        switch (type) {
            case "search":
                inputType = "text";
                break;
            default:
                inputType = "text";
        }

        return (
            <div className={classNamesPrefixed({
                [classes]: true,
                'field': true,
                ["field--" + type]: type ? true : false,
                ["field--" + inputType]: inputType ? true : false,
                ["field--" + id]: id ? true : false,
                "field--focused": focused ? true : false,
                "field--error": error ? true : false,
                "field--warning": warning ? true : false
            })}>

                {label &&
                <label htmlFor={id} className={classNamesPrefixed({"field__label": true})}>
                    {label}

                    {required && <span className={classNamesPrefixed({"field__required": true})}>*</span>}

                    {helpText && <span className={classNamesPrefixed({"info__label": true})} data-tip={helpText} data-for="help-text-tooltip"></span>}

                </label>
                }

                <div className={classNamesPrefixed({"field__wrap": true})}>
                    {children}

                    {icon &&
                    <Icon name={icon}/>
                    }
                </div>

                {error &&
                <div className={classNamesPrefixed(
                    {
                        "field__error": true
                    }
                )}>
                    {error}
                </div>
                }

                {warning &&
                <div className={classNamesPrefixed({
                    "field__error": true
                })}>
                    {warning}
                </div>
                }
            </div>
        );
    };
}

InputWrap.propTypes = {
    classes: PropTypes.string
};

InputWrap.defaultProps = {
    classes: ''
}

export default InputWrap;



// WEBPACK FOOTER //
// ./src/core/admin/components/Fields/InputWrap.js